import { css } from 'linaria';

export const mobileFixedPanelCreator = css`
  @media (--only-tablet) {
    width: 100%;
    background-color: var(--background-accent);
    transition: all 0.5s;
  }
`;

export const hiddenMobilePanel = css`
  display: none;
`;

export const mobilePanel = css`
  height: 0;
  overflow: hidden;
  transform: translateY(100%);
  transition: all 0.4s ease;
`;

export const fixedMobilePanel = css`
  @media (--to-desktop) {
    position: fixed;
    top: unset;
    z-index: 900;
    width: 100%;
    height: auto;
    transform: translateY(0);
  }
`;

export const fixedMobilePanelWithWhiteBack = css`
  @media (--only-mobile) {
    padding: 16px 0;
    margin-bottom: -16px;
    background-color: var(--background-primary);
  }
`;
